import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { superAdminAPI } from '../../services/api';
import AuditLogsView from '../../components/AuditLogs/AuditLogsView';

/**
 * Audit Logs — superadmin view
 * Shows audit events across ALL organizations, filterable by organization.
 */
const SuperAdminAuditLogs = () => {
  // Organization list for the filter dropdown
  const { data: orgsData } = useQuery({
    queryKey: ['audit-logs-org-options'],
    queryFn: () => superAdminAPI.getOrganizations({ limit: 500 }),
    refetchOnWindowFocus: false,
  });

  const organizations = orgsData?.data?.data || [];
  const orgOptions = organizations.map((org) => ({
    value: org._id,
    label: org.name,
  }));

  return (
    <div className="space-y-6">
      <AuditLogsView mode="superadmin" orgOptions={orgOptions} />
    </div>
  );
};

export default SuperAdminAuditLogs;